export default {
	loading: false,
	cargoCarriers: [],
	errors: {
		palletCapacity: false,
		weight: false,
		volume: false,
		loadingMeters: false,
		iconId: false,
		id: ''
	}
};
